import React from "react";
import RedirectToBookshelf from "../../common/ui/RedirectToBookshelf";
import { useBrand } from "../../common/providers/brand/brand-context";
import { getAppBaseUrl } from "../../main/utils";

export default function NotFound(props) {
  const brand = useBrand();
  const params = new URLSearchParams();
  params.set("theme", brand.getProp<string>("Theme.primary"));
  params.set("locale", brand.getProp<string>("locale"));
  if (props.location.state) {
    params.set("missingURL", getAppBaseUrl() + props.location.state.referrer);
  }

  return (
    <RedirectToBookshelf
      path={`/error/not-found?${params.toString()}`}
      replace
    />
  );
}
